module.exports = __webpack_public_path__ + "static/img/left-resting-hand.cde1e84c.webp";